const SIGN_UP_AFTER_TRADE_ATTEMPT_KEY = 'signUpAfterTradeAttempt';

export interface SignUpAfterTradeAttempt {
	marketId?: string;
	lobbyId?: string;
	eventId?: string;
	position?: string;
	market?: string;
	lobbyName?: string;
	eventName?: string;
	source?: string;
	attemptedAt: string;
}

export function markSignUpAfterTradeAttempt(attempt: Omit<SignUpAfterTradeAttempt, 'attemptedAt'>) {
	if (typeof window === 'undefined') return;

	sessionStorage.setItem(
		SIGN_UP_AFTER_TRADE_ATTEMPT_KEY,
		JSON.stringify({
			...attempt,
			attemptedAt: new Date().toISOString(),
		})
	);
}

export function consumeSignUpAfterTradeAttempt(): SignUpAfterTradeAttempt | null {
	if (typeof window === 'undefined') return null;

	const raw = sessionStorage.getItem(SIGN_UP_AFTER_TRADE_ATTEMPT_KEY);
	if (!raw) return null;

	sessionStorage.removeItem(SIGN_UP_AFTER_TRADE_ATTEMPT_KEY);

	try {
		return JSON.parse(raw) as SignUpAfterTradeAttempt;
	} catch {
		return null;
	}
}
